import React, { useEffect, useRef } from "react";
import { ReactComponent as UIUX } from "../../assets/UIUX.svg";
import { ReactComponent as WebDesign } from "../../assets/WebDesign.svg";
import { ReactComponent as AppDesign } from "../../assets/AppDesign.svg";
import { ReactComponent as Graphic } from "../../assets/Graphic.svg";
import { ReactComponent as Brand } from "../../assets/Brand.svg";
import { ReactComponent as Code } from "../../assets/Code.svg";

import ServiceCard from "./ServiceCard/ServiceCard";
import "./ServicesSection.css";

const ServicesSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const elements = sectionRef.current.querySelectorAll(".reveal");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="services" className="services-wrapper" ref={sectionRef}>
      <div className="services-blur-shape" aria-hidden="true" />

      <div className="services-text reveal">
        <h5>SERVICES</h5>
        <h2>My Specialties</h2>
      </div>

      <div className="services-grid">
        <div className="reveal">
          <ServiceCard
            icon={<UIUX />}
            iconWidth={56}
            iconHeight={60}
            title="UI/UX Design"
            description="Crafting intuitive, appealing interfaces that improve usability and elevate overall user experience."
          />
        </div>

        <div className="reveal">
          <ServiceCard
            icon={<WebDesign />}
            iconWidth={60}
            iconHeight={58.63}
            title="Website Design"
            description="Creating clean, responsive websites that enhance brand presence and deliver seamless user interaction."
          />
        </div>

        <div className="reveal">
          <ServiceCard
            icon={<AppDesign />}
            iconWidth={39}
            iconHeight={60}
            title="Mobile App Design"
            description="Designing sleek, intuitive mobile apps that simplify user journeys and make everyday tasks effortless."
          />
        </div>

        <div className="reveal">
          <ServiceCard
            icon={<Graphic />}
            iconWidth={80}
            iconHeight={50}
            title="Graphic Design"
            description="Delivering bold, visually compelling graphics that strengthen brand identity and captivate your audience."
          />
        </div>

        <div className="reveal">
          <ServiceCard
            icon={<Brand />}
            iconWidth={43.05}
            iconHeight={64}
            title="Brand Design"
            description="Building cohesive, memorable brand identities that communicate value and leave a lasting impression."
          />
        </div>

        <div className="reveal">
          <ServiceCard
            icon={<Code />}
            iconWidth={70}
            iconHeight={57.99}
            title="Web Development"
            description="Developing robust, scalable websites that combine functionality with seamless user experiences."
          />
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
